var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", {
    staticClass: "relative w-100 h-100 header-spacer home bg-beige",
    class: { "is-reduced": _vm.headerSpacerIsReduced },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }